import { call, takeEvery } from 'redux-saga/effects';
import { ProspectConstants } from 'constants/prospect';
import { request } from 'components/Fetch';
import { apiUrls } from 'config/urls';

function* importProspectApplicationIdSaga(action) {
  yield call(request({
    type: ProspectConstants.PROSPECT_IMPORT_APPLICATION_ID,
    method: 'POST',
    url: apiUrls.importProspectApplications({ id: null }),
  }), action);
}

function* importProspectApplicationsSaga(action) {
  const { id } = action.payload;
  yield call(request({
    type: ProspectConstants.PROSPECT_IMPORT_APPLICATIONS,
    method: 'GET',
    url: apiUrls.importProspectApplications({ id }),
  }), action);
}

export default function* () {
  yield takeEvery(ProspectConstants.PROSPECT_IMPORT_APPLICATION_ID, importProspectApplicationIdSaga);
  yield takeEvery(ProspectConstants.PROSPECT_IMPORT_APPLICATIONS, importProspectApplicationsSaga);
}



// WEBPACK FOOTER //
// ./src/sagas/prospectSaga.js